module.exports = __webpack_public_path__ + "static/img/banner.469d18f1.jpg";